import DefaultLayout from '@/layouts/DefaultLayout.vue'
import homeRouteGuard from '@/router/routeGuards/homeRouteGuard'
import shippingRouteGuard from '@/router/routeGuards/shippingRouteGuard'
import { pinia } from '@/stores'
import { useUserStore, OperationType } from '@/stores/user.store'
import ErrorView from '@/views/Error/ErrorView.vue'
import ExceptionView from '@/views/Exception/ExceptionView.vue'
import HomeView from '@/views/Home/HomeView.vue'
import LoginView from '@/views/Login/LoginView.vue'
import MoDetailsView from '@/views/MoDetails/MoDetailsView.vue'
import NonConformityFormView from '@/views/NonConformityForm/NonConformityFormView.vue'
import ShippingView from '@/views/Shipping/ShippingView.vue'
import TestsView from '@/views/Tests/TestsView.vue'
import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { config } from '../default'
import ReadProductDetailsView from '@/views/ReadProductDetails/ReadProductDetailsView.vue'
import HomeViewProduct from '@/views/HomeProduct/HomeViewProduct.vue'
import HistoryView from '@/views/History/HistoryView.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    beforeEnter: (to, from, next) => {
      homeRouteGuard.beforeEnter(to, from, next)
    },
    meta: {
      requiresData: true,
      layout: DefaultLayout,
      showNavBar: true
    }
  },
  {
    path: '/home-read-product',
    name: 'home-read-product',
    component: HomeViewProduct,
    meta: {
      previousRoute: 'home',
      layout: DefaultLayout,
      showNavBar: true
    }
  },
  {
    path: '/history',
    name: 'history',
    component: HistoryView,
    beforeEnter: (to, from, next) => {
      const userStore = useUserStore(pinia)
      const operationType = userStore.decodedToken?.productionSequenceOperation.operation.type
      if (operationType === OperationType.SHIPPING) {
        return next({ name: 'shipping' })
      }
      next()
    },
    meta: {
      previousRoute: 'home',
      layout: DefaultLayout,
      showNavBar: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      requiresData: false,
      layout: DefaultLayout,
      showNavBar: false
    }
  },
  {
    path: '/manufacturing-order',
    name: 'manufacturing-order',
    component: MoDetailsView,
    meta: {
      previousRoute: 'home',
      layout: DefaultLayout,
      showNavBar: true
    }
  },
  {
    path: '/read-product',
    name: 'read-product',
    component: ReadProductDetailsView,
    meta: {
      previousRoute: 'home-read-product',
      layout: DefaultLayout,
      showNavBar: true
    }
  },
  {
    path: '/non-conformity-form',
    name: 'non-conformity-form',
    component: NonConformityFormView,
    meta: {
      previousRoute: 'manufacturing-order',
      layout: DefaultLayout,
      showNavBar: true
    }
  },
  {
    path: '/shipping',
    name: 'shipping',
    component: ShippingView,
    beforeEnter: (to, from, next) => {
      shippingRouteGuard.beforeEnter(to, from, next)
    },
    meta: {
      layout: DefaultLayout,
      showNavBar: true
    }
  },
  {
    path: '/exception',
    name: 'exception',
    component: ExceptionView,
    meta: {
      layout: DefaultLayout,
      showNavBar: true
    }
  },
  {
    path: '/error',
    name: 'error',
    component: ErrorView
  }
]

if (config.environment === 'dev') {
  routes.push({
    path: '/tests',
    name: 'tests',
    component: TestsView,
    meta: {
      showNavBar: true
    }
  })
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const userStore = useUserStore(pinia)

  if (to.name === 'tests') {
    next()
    return
  }

  if (userStore.jwtToken && to.name === 'login') {
    next({ name: 'home' })
    return
  }

  if (!userStore.jwtToken && to.name !== 'login') {
    next({ name: 'login' })
    return
  }

  next()
})

export default router
